import { Moon, Sun } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useTheme } from '@/components/theme-provider'

/** Toggle light/dark del NeoCore. Muestra el ícono del modo actual. */
export function ThemeToggle() {
  const { theme, toggle } = useTheme()
  const isDark = theme === 'dark' || (theme === 'system' && typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches)
  return (
    <Button variant="ghost" size="icon" onClick={toggle} aria-label="Cambiar tema" title={isDark ? 'Cambiar a claro' : 'Cambiar a oscuro'}>
      {isDark ? <Sun className="size-[18px]" /> : <Moon className="size-[18px]" />}
    </Button>
  )
}
